'use client';
import Script from 'next/script';
import React, { useEffect, useState } from 'react';

const PlugSdk: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    (window as any).plugSDK.init({
      app_id:
        'DvRvStPZG9uOmNvcmU6ZHZydi1pbi0xOmRldm8vMjE4ZlpHdnN4bDpwbHVnX3NldHRpbmcvMV9ffHxfXzIwMjUtMDItMDcgMDg6NDc6MjMuMDQ1MDkwMTA2ICswMDAwIFVUQw==xlxendsDvRv',
      disable_plug_chat_window: true,
    });
  }, []);
  return (
    <Script src="https://plug-platform.devrev.ai/static/plug.js" strategy="beforeInteractive" />
  );
};

export default PlugSdk;
